import React from 'react';
import './UserProfile.css';

function UserProfile({ user, onLogout }) {
  if (!user) {
    return (
      <div className="user-profile loading">
        <div className="profile-skeleton">
          <div className="avatar-skeleton"></div>
          <div className="user-info-skeleton">
            <div className="username-skeleton"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-profile">
      <div className="profile-content">
        <div className="user-avatar">
          <img 
            src={user.avatar_template} 
            alt={`${user.username}'s avatar`}
            onError={(e) => {
              e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiM4YjVjZjYiLz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4PSI4IiB5PSI4Ij4KPHBhdGggZD0iTTEyIDJDMTMuMSAyIDE0IDIuOSAxNCA0QzE0IDUuMSAxMy4xIDYgMTIgNkMxMC45IDYgMTAgNS4xIDEwIDRDMTAgMi45IDEwLjkgMiAxMiAyWk0yMSAyMkgtM1YyMEM5IDE2IDEzIDE2IDIxIDIwVjIyWiIgZmlsbD0id2hpdGUiLz4KPHN2Zz4KPHN2Zz4=';
            }}
          />
        </div>
        <div className="user-info">
          <span className="username">{user.username}</span>
          <span className="user-id">ID: {user.id}</span>
        </div>
      </div>
      <button className="logout-button" onClick={onLogout}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
        </svg>
      </button>
    </div>
  );
}

export default UserProfile;